import { useAppContext } from 'components/Context/AppContext';
import {
  AreaCharter,
  Button,
  InputField,
  SelectFieldAdditionalItem,
  SelectFieldDuration,
  SelectFieldPassengerAndLuggage,
} from 'components/Global';
import InputTelpField from 'components/Global/InputTelpField';
import NewUploadImageCustomOrder from 'components/Global/NewUploadImageCustomOrder';
import SelectFieldCar from 'components/Global/SelectFieldCar';
import SelectFieldDate from 'components/Global/SelectFieldDate';
import SelectFieldDropdown from 'components/Global/SelectFieldDropdown';
import SelectFieldShuttle from 'components/Global/SelectFieldShuttle';
import { addDays, format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { checkEmptyObject, normalizeTimeFormat, setCurrency } from 'utils/functionality';
import RentTimeComponents from './RentTimeComponents';
import { fetchSummaryOrder } from 'features/orders/actions';

export const STATIC_DISABLED_TIME_CHARTER_SG = [
  '00:00',
  '00:30',
  '01:00',
  '01:30',
  '02:00',
  '02:30',
  '03:00',
  '03:30',
  '04:00',
  '04:30',
  '05:00',
  '05:30',
  '06:00',
  '06:30',
  '20:30',
  '21:00',
  '21:30',
  '22:00',
  '22:30',
  '23:00',
  '23:30',
];

const paymentType = [
  {
    id: 'pyt1',
    name: 'Pembayaran Full',
    value: 'FULL',
  },
  {
    id: 'pyt2',
    name: 'Pembayaran DP',
    value: 'HALF',
  },
];

const regexEmail =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const DetailSewaPage = ({
  allVehicle,
  vehicleInput,
  setVehicleInput,
  orderData,
  setOrderData,
  rentalLocation,
  rentalLocationHandler,
  startRentDate,
  setStartRentDate,
  durationRent,
  setDurationRent,
  selectedCar,
  setSelectedCar,
  selectedAdditionalItem,
  setSelectedAdditionalItem,
  selectedPaymentType,
  setSelectedPaymentType,
  selectedLuggage,
  selectedPassengers,
  setSelectedLuggage,
  setSelectedPassengers,
  ktpImageLink,
  setKtpImageLink,
  passportImageLink,
  setPassportImageLink,
  allRentTime,
  setAllRentTime,
  allAreaCharter,
  setAllAreaCharter,
  nextPage,
  isOrderConfirmation,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { showToast } = useAppContext();

  const { data: rentalLocationData } = useSelector((state) => state.rentalLocation);
  const { data: rentalServicesData } = useSelector((state) => state.services);
  const { data: additionalData } = useSelector((state) => state.addon);
  const { data: summaryOrderData } = useSelector((state) => state.summaryOrder);
  const { data: unavailableDatesData } = useSelector((state) => state.unavailableDates);

  const getSubserviceId = () => {
    const subServiceId = rentalServicesData
      ?.find((item) => item.name === 'Sewa Mobil')
      ?.sub_services?.find((item) => item.name === 'Daily')
      ?.facilities?.find((item) => item.name === 'Charter');

    return subServiceId?.id;
  };

  const [additionalSearchInput, setAdditionalSearchInput] = useState('');
  const [mappedPaymentType, setMappedPaymentType] = useState(paymentType);

  const allAreaCharterCheckingValidation = (areaCharters) => {
    const excludedProps = [
      'booking_end_time',
      'booking_start_time',
      'charter_duration',
      'startLocation',
      'endLocation',
      'sameLocation',
    ];
    return (
      areaCharters?.length !== 0 &&
      areaCharters.every((area) =>
        Object.entries(area)
          .filter(([key]) => !excludedProps.includes(key)) // buang prop yang dikecualikan
          // eslint-disable-next-line no-unused-vars
          .every(([__, val]) => {
            if (typeof val === 'string') {
              return val.trim() !== '';
            }

            return Boolean(val);
          }),
      )
    );
  };

  // GET SUMMARY
  useEffect(() => {
    if (
      !rentalLocation ||
      !orderData?.order_detail?.end_booking_date ||
      !orderData?.order_detail?.start_booking_date ||
      !allRentTime ||
      allRentTime.length === 0 ||
      !selectedCar ||
      isOrderConfirmation
    )
      return;

    const fetchSummary = async () => {
      const sub_service_id = getSubserviceId();

      const payload = {
        end_booking_date: orderData?.order_detail?.end_booking_date,
        end_booking_time: allRentTime[allRentTime?.length - 1]?.booking_end_time,
        start_booking_date: orderData?.order_detail?.start_booking_date,
        start_booking_time: allRentTime[0]?.booking_start_time,
        order_type_id: 8,
        vehicle_id: orderData?.order_detail?.vehicle_id,
        without_driver: 0,
        vehicle_category_id: selectedCar?.category?.id,
        pasengger_number: +orderData?.order_detail?.adult_passenger + +orderData?.order_detail?.child_passenger,
        overtime: 0,
        location_id: rentalLocation?.id,
        sub_services_id: sub_service_id,
      };

      try {
        const response = await dispatch(fetchSummaryOrder(payload));
        if (response.meta?.requestStatus === 'fulfilled') {
          return;
        }
        showToast({ type: 'error', message: 'Terjadi Kesalahan' });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        showToast({ type: 'error', message: 'Terjadi Kesalahan' });
      }
    };

    fetchSummary();
  }, [
    rentalLocation,
    orderData?.order_detail?.end_booking_date,
    orderData?.order_detail?.start_booking_date,
    allRentTime,
    selectedCar,
    isOrderConfirmation,
  ]);

  useEffect(() => {
    if (!selectedCar && allRentTime?.length !== 0) return;

    const newAllRentTime = [...allRentTime].map((rent) => ({
      charter_duration: undefined,
      ...rent,
    }));

    setAllRentTime(newAllRentTime);
  }, [selectedCar]);

  // SET PAYMENT TYPE
  useEffect(() => {
    if (!Object.keys(summaryOrderData).length) return;

    if (summaryOrderData.total_dp > 0) {
      const newPaymentType = paymentType.map((item) =>
        item.id == 'pyt2'
          ? {
              ...item,
              name: `${
                item.name.includes('%')
                  ? item.name
                  : summaryOrderData?.formula_percentage?.value
                  ? `${item.name} ${summaryOrderData.formula_percentage.value}%`
                  : item.name
              }`,
            }
          : item,
      );
      setMappedPaymentType(newPaymentType);
    } else if (summaryOrderData.total_dp === 0) {
      setMappedPaymentType((prev) => prev.filter((item) => item.id !== 'pyt2'));
      setSelectedPaymentType('pyt1');
      setOrderData({ ...orderData, type: paymentType.find((pay) => pay.id === 'pyt1')?.value });
    }
  }, [summaryOrderData]);

  const backHandler = () => {
    navigate('/car-charter?status=ALL&locationId=ALL');
  };

  const uploadImageAction = (file, name, link) => {
    const lowerCaseName = name.toLocaleLowerCase();
    let identityObject;

    if (lowerCaseName === 'ktp') {
      setKtpImageLink(link);

      if (orderData.order_detail.identity === null) {
        identityObject = { [lowerCaseName]: file.file, sim: null };
      } else {
        identityObject = { ...orderData.order_detail.identity, [lowerCaseName]: file.file };
      }
    } else {
      setPassportImageLink(link);
      if (orderData.order_detail.identity === null) {
        identityObject = { [lowerCaseName]: file.file, ktp: null };
      } else {
        identityObject = { ...orderData.order_detail.identity, [lowerCaseName]: file.file };
      }
    }

    setOrderData({
      ...orderData,
      order_detail: {
        ...orderData.order_detail,
        identity: identityObject,
      },
    });
  };

  const changeStartDateHandler = (date) => {
    if (date) {
      setStartRentDate(date);
      setOrderData({
        ...orderData,
        order_detail: {
          ...orderData.order_detail,
          vehicle_id: '',
          start_booking_date: format(date, 'yyyy-MM-dd').toString(),
          end_booking_date: durationRent ? format(addDays(date, durationRent - 1), 'yyyy-MM-dd').toString() : '',
        },
      });
      setSelectedCar(undefined);
      setAllAreaCharter([]);
      setAllRentTime([]);
      setDurationRent(0);
      setSelectedAdditionalItem(undefined);
    }
  };

  const durationRentDateHandler = (duration) => {
    setDurationRent(duration);
    setSelectedCar(undefined);
    setOrderData({
      ...orderData,
      order_detail: {
        ...orderData.order_detail,
        end_booking_date: format(addDays(startRentDate, duration - 1), 'yyyy-MM-dd').toString(),
        vehicle_id: '',
      },
    });
    setSelectedAdditionalItem(undefined);
    setAllAreaCharter([]);

    let arrayRentTime = [];

    for (let i = 0; i < duration; i++) {
      arrayRentTime.push({
        charter_duration: undefined,
        booking_start_time: '',
        booking_end_time: '',
      });
    }
    setAllRentTime(arrayRentTime);
  };

  const selectVehicleHandler = (vehicleId, resetVehicle) => {
    if (vehicleId === '') {
      setVehicleInput(resetVehicle);
      return;
    }
    setOrderData({ ...orderData, order_detail: { ...orderData.order_detail, vehicle_id: vehicleId } });
    setVehicleInput(resetVehicle);
  };

  const passangerAndLuggageHandler = (passengers, luggage) => {
    setSelectedPassengers(passengers);
    setSelectedLuggage(luggage);
    setOrderData({
      ...orderData,
      order_detail: {
        ...orderData.order_detail,
        adult_passenger: passengers.adults,
        child_passenger: passengers.child,
        baggage: luggage.luggage,
      },
    });
  };

  const submitHandler = async () => {
    const validLocation = rentalLocation !== undefined && !checkEmptyObject(rentalLocation);
    const validUsername = orderData?.user_name.replace(/\s/g, '').length !== 0;
    const validUserWaNumber = !!orderData?.wa_number && orderData.wa_number.replace(/\s/g, '').length !== 0;
    const validUserEmail = new RegExp(regexEmail).test(orderData?.email);
    const validKTP = orderData?.order_detail?.identity?.ktp;
    const validPassport = orderData?.order_detail?.identity?.passport;
    const validStartBookingDate = orderData.order_detail.start_booking_date !== '';
    const validDurationRent = durationRent !== 0;
    const validRentTime =
      allRentTime?.length !== 0 &&
      allRentTime.every((time) => time.booking_start_time && time.booking_start_time.trim() !== '');
    const validVehicle = orderData.order_detail.vehicle_id !== '';
    const validRentCharterTime =
      allRentTime?.length !== 0 && allRentTime.every((time) => time.charter_duration !== undefined);
    const validPaymentType = !!orderData?.type || !!selectedPaymentType;
    const validLuggage = orderData.order_detail.baggage;
    const validPassengers = orderData.order_detail.adult_passenger || orderData.order_detail.child_passenger;
    const validAreaCharter = allAreaCharterCheckingValidation(allAreaCharter);

    if (!validLocation) {
      return showToast({ type: 'error', message: 'Pilih Lokasi!' });
    }

    if (!validUsername) {
      return showToast({ type: 'error', message: 'Nama tidak Valid!' });
    }

    if (!validUserWaNumber) {
      return showToast({ type: 'error', message: 'Nomor WA tidak Valid!' });
    }

    if (!validUserEmail) {
      return showToast({ type: 'error', message: 'Email tidak valid' });
    }

    if (!validKTP) {
      return showToast({ type: 'error', message: 'Upload KTP' });
    }

    if (!validPassport) {
      return showToast({ type: 'error', message: 'Upload Passport' });
    }

    if (!validStartBookingDate) {
      return showToast({ type: 'error', message: 'Pilih Tanggal Mulai' });
    }

    if (!validDurationRent) {
      return showToast({ type: 'error', message: 'Pilih Durasi Charter' });
    }

    if (!validRentTime) {
      return showToast({ type: 'error', message: 'Pilih Jam Mulai!' });
    }

    if (!validVehicle) {
      return showToast({ type: 'error', message: 'Pilih Mobil' });
    }

    if (!validRentCharterTime) {
      return showToast({ type: 'error', message: 'Pilih Durasi Sewa!' });
    }

    if (!validPaymentType) {
      return showToast({ type: 'error', message: 'Pilih Tipe Pembayaran' });
    }

    if (!validPassengers) {
      return showToast({ type: 'error', message: 'Piih Jumlah Penumpang' });
    }

    if (!validLuggage) {
      return showToast({ type: 'error', message: 'Piih Jumlah Koper' });
    }

    if (!validAreaCharter) {
      return showToast({ type: 'error', message: 'Pilih Area Charter' });
    }

    const orderBookingZone = [...allAreaCharter]
      .map((area, index) => ({
        ...area,
        charter_duration: allRentTime[index]?.charter_duration?.duration,
        booking_start_time: normalizeTimeFormat(allRentTime[index]?.booking_start_time),
        booking_end_time: normalizeTimeFormat(allRentTime[index]?.booking_end_time),
      }))
      .map((area) => ({
        ...area,
        endLocation: undefined,
        startLocation: undefined,
        sameLocation: undefined,
      }));

    const serviceSewaMobil = rentalServicesData.find((item) => item.name === 'Sewa Mobil');

    const service_id = serviceSewaMobil?.id;
    const sub_service_id = rentalServicesData
      ?.find((item) => item.id === service_id)
      ?.sub_services?.find((item) => item.name === 'Daily')
      ?.facilities?.find((item) => item.name === 'Charter')?.id;

    let mappingAdditionalItem = [];

    if (selectedAdditionalItem) {
      for (let addItionalChild of selectedAdditionalItem) {
        const additionalObj = {
          id: addItionalChild.additional.id,
          varieties: [
            {
              id: addItionalChild.additional.varieties[0].id,
              quantity: addItionalChild.total,
            },
          ],
        };

        mappingAdditionalItem.push(additionalObj);
      }
    }

    const payload = {
      end_booking_date: orderData?.order_detail?.end_booking_date,
      end_booking_time: allRentTime[allRentTime?.length - 1]?.booking_end_time,
      start_booking_date: orderData?.order_detail?.start_booking_date,
      start_booking_time: allRentTime[0]?.booking_start_time,
      order_type_id: 8,
      vehicle_id: orderData?.order_detail?.vehicle_id,
      without_driver: 0,
      order_booking_zone: orderBookingZone,
      vehicle_category_id: selectedCar?.category?.id,
      pasengger_number: +orderData?.order_detail?.adult_passenger + +orderData?.order_detail?.child_passenger,
      overtime: 0,
      location_id: rentalLocation?.id,
      sub_services_id: sub_service_id,
      addons: mappingAdditionalItem,
    };

    try {
      const response = await dispatch(fetchSummaryOrder(payload));
      if (response.meta?.requestStatus === 'fulfilled') {
        nextPage();
        return;
      }
      showToast({ type: 'error', message: 'Terjadi Kesalahan' });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      showToast({ type: 'error', message: 'Terjadi Kesalahan' });
    }
  };

  return (
    <div className="detail-sewa-car-charter" style={{ marginBottom: isOrderConfirmation ? '0' : '100px' }}>
      <div className="detail-sewa-car-charter__penyewa">
        <h2>Detail Penyewa</h2>
        <div className="detail-sewa-car-charter__penyewa-form">
          <SelectFieldShuttle
            label="Lokasi"
            htmlFor="lokasi-rental"
            data={rentalLocationData}
            value={rentalLocation?.id}
            onChange={rentalLocationHandler}
            placeholder="Pilih Lokasi"
            searchFeature
            disable={isOrderConfirmation}
          />

          <InputField
            type="text"
            label="Nama Penyewa"
            htmlFor="nama-penyewa"
            placeholder="Tulis Nama Penyewa"
            value={orderData.user_name}
            onChange={(e) => setOrderData({ ...orderData, user_name: e.target.value })}
            disable={isOrderConfirmation}
          />

          <InputTelpField
            label="No Telpon / Whatsapp"
            htmlFor="telp-penyewa"
            value={orderData.wa_number || ''}
            onChange={(e) => setOrderData({ ...orderData, wa_number: e.target.value, phone_number: e.target.value })}
            disable={isOrderConfirmation}
            countryCodeValue={orderData.phone_country_code}
            onSelectCountry={(code) => setOrderData({ ...orderData, phone_country_code: code })}
          />

          <InputField
            type="text"
            label="Email"
            htmlFor="email-penyewa"
            placeholder="Masukan Email"
            value={orderData.email}
            onChange={(e) => setOrderData({ ...orderData, email: e.target.value })}
            disable={isOrderConfirmation}
          />

          <NewUploadImageCustomOrder
            label="KTP"
            htmlFor="KTP"
            uploadAction={uploadImageAction}
            imageFile={ktpImageLink}
            base64={true}
            disable={isOrderConfirmation}
          />

          <NewUploadImageCustomOrder
            label="Passport"
            htmlFor="passport"
            uploadAction={uploadImageAction}
            imageFile={passportImageLink}
            base64={true}
            disable={isOrderConfirmation}
          />
        </div>
      </div>

      <div className="detail-sewa-car-charter__detail-hari">
        <h2>Detail Hari</h2>
        <div className="detail-sewa-car-charter__detail-hari-form">
          <SelectFieldDate
            label="Tanggal Mulai"
            htmlFor="tanggal-mulai"
            name="tanggal-mulai"
            handleDaySelect={changeStartDateHandler}
            selectedDay={startRentDate}
            value={startRentDate !== '' ? format(startRentDate, 'dd-MM-yyyy') : startRentDate}
            placeholder="Pilih Tanggal"
            disable={isOrderConfirmation}
          />

          <SelectFieldDuration
            label="Durasi Charter"
            htmlFor="durasi-charter"
            placeholder="0 Hari"
            startDate={startRentDate}
            value={durationRent}
            onClick={durationRentDateHandler}
            disable={isOrderConfirmation ? true : startRentDate ? false : true}
            maxDuration={7}
          />

          <RentTimeComponents
            durationRent={durationRent}
            startDate={startRentDate}
            disable={isOrderConfirmation}
            charterPricingData={selectedCar?.charter_pricing ?? []}
            allRentTime={allRentTime}
            setAllRentTime={setAllRentTime}
            disabledTimes={{ disabledTimes: unavailableDatesData, startDate: startRentDate }}
            staticDisabledTime={STATIC_DISABLED_TIME_CHARTER_SG}
          />
        </div>
      </div>

      <div className="detail-sewa-car-charter__detail-sewa">
        <h2>Detail Sewa</h2>
        <div className="detail-sewa-car-charter__detail-sewa-form">
          <SelectFieldCar
            label="Pilih Mobil"
            htmlFor="pilih-mobil"
            placeholder="Cari Mobil.."
            data={allVehicle}
            selectedCar={selectedCar}
            onSelectCar={setSelectedCar}
            value={vehicleInput}
            onChange={(e) => setVehicleInput(e.target.value)}
            onClick={selectVehicleHandler}
            payloadFilter={{
              locationRental: rentalLocation?.id,
              startTrip: `${orderData.order_detail.start_booking_date} ${orderData.order_detail.start_booking_time}`,
              endTrip: `${orderData.order_detail.end_booking_date} ${orderData.order_detail.end_booking_time}`,
              customOrder: true,
              page: 0,
              limit: 0,
              subServiceId: getSubserviceId(),
              supportCharter: true,
            }}
            disable={
              isOrderConfirmation
                ? true
                : !rentalLocation ||
                  orderData.order_detail.start_booking_date === '' ||
                  orderData.order_detail.end_booking_date === '' ||
                  allRentTime?.length === 0 ||
                  allRentTime[0]?.booking_start_time === '' ||
                  allRentTime[allRentTime?.length - 1]?.booking_end_time === ''
            }
          />

          <SelectFieldDropdown
            label="Tipe Pembayaran"
            htmlFor="tipe-pembayaran"
            value={selectedPaymentType}
            data={mappedPaymentType}
            onChange={(e) => {
              setSelectedPaymentType(e.target.id);
              setOrderData({
                ...orderData,
                type: mappedPaymentType?.find((item) => item.id == e.target.id)?.value,
              });
            }}
            placeholder="Tipe Pembayaran"
            disable={
              orderData.order_detail.start_booking_date === '' ||
              orderData.order_detail.end_booking_date === '' ||
              allRentTime?.length === 0 ||
              allRentTime[0]?.booking_start_time === '' ||
              orderData.order_detail.vehicle_id === '' ||
              isOrderConfirmation
            }
          />

          <SelectFieldPassengerAndLuggage
            label="Jumlah Penumpang"
            htmlFor="passengers-and-suitcase"
            selectedLuggage={selectedLuggage}
            selectedPassengers={selectedPassengers}
            onSelect={passangerAndLuggageHandler}
            disable={isOrderConfirmation}
          />
        </div>
      </div>

      <div className="detail-sewa-car-charter__area-charter">
        <h2>Detail Area Charter</h2>
        <AreaCharter
          durationRentDate={durationRent}
          startDate={startRentDate}
          forCustomOrder
          rentalLocation={rentalLocation}
          allAreaCharter={allAreaCharter}
          setAllAreaCharter={setAllAreaCharter}
          disable={isOrderConfirmation}
          sameLocationCheck
        />
      </div>

      <div className="detail-sewa-car-charter__additional">
        <h2>Additional</h2>
        <div className="detail-sewa-car-charter__additional-form">
          <SelectFieldAdditionalItem
            label="Pilih Tambahan"
            id="tambahan"
            placeholder="Cari Perlengkapan Khusus.."
            selectedAdditionalItem={selectedAdditionalItem}
            setSelectedAdditionalItem={setSelectedAdditionalItem}
            value={additionalSearchInput}
            onChange={(e) => setAdditionalSearchInput(e.target.value)}
            data={additionalData?.data || []}
            disable={isOrderConfirmation || !additionalData || checkEmptyObject(additionalData)}
            filterParams={{
              locationId: rentalLocation?.id,
              locTimeId: rentalLocation?.time_zone_identifier,
              startDate: orderData.order_detail.start_booking_date,
              endDate: orderData.order_detail.end_booking_date,
              startTime: normalizeTimeFormat(orderData.order_detail.start_booking_time),
              endTime: normalizeTimeFormat(orderData.order_detail.end_booking_time),
            }}
          />

          {isOrderConfirmation && (
            <InputField
              label="Total Biaya Permintaan Khusus"
              placeholder="IDR 0"
              value={
                summaryOrderData?.addon_total_price && selectedAdditionalItem
                  ? setCurrency(summaryOrderData.addon_total_price)
                  : ''
              }
              disable
            />
          )}
        </div>
      </div>

      {!isOrderConfirmation && (
        <div className="detail-sewa-car-charter__btn-action">
          <Button
            type="button"
            variant="outline"
            width="165px"
            height="39px"
            size="md"
            className="button"
            onClick={backHandler}
          >
            Kembali
          </Button>
          <Button type="button" width="165px" height="39px" size="md" className="button" onClick={submitHandler}>
            Lanjutkan
          </Button>
        </div>
      )}
    </div>
  );
};

export default DetailSewaPage;
